import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import AdviceCard from '~/components/Advice/AdviceCard.vue';
export default defineComponent({
  name: 'BlockAdviceList',
  components: {
    NativeCarousel: NativeCarousel,
    AdviceCard: AdviceCard
  },
  props: {
    relatedAdvices: {
      type: Object,
      default: null
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var listOfAdvices = computed(function () {
      var _props$relatedAdvices, _props$relatedAdvices2;
      return (_props$relatedAdvices = props.relatedAdvices) === null || _props$relatedAdvices === void 0 ? void 0 : (_props$relatedAdvices2 = _props$relatedAdvices.advices) === null || _props$relatedAdvices2 === void 0 ? void 0 : _props$relatedAdvices2.filter(function (advice) {
        var _advice$fields;
        return (advice === null || advice === void 0 ? void 0 : (_advice$fields = advice.fields) === null || _advice$fields === void 0 ? void 0 : _advice$fields.slug) || advice.slug;
      });
    });
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var isScrollable = computed(function () {
      var _listOfAdvices$value, _listOfAdvices$value2;
      return isMobile.value ? ((_listOfAdvices$value = listOfAdvices.value) === null || _listOfAdvices$value === void 0 ? void 0 : _listOfAdvices$value.length) > 2 : ((_listOfAdvices$value2 = listOfAdvices.value) === null || _listOfAdvices$value2 === void 0 ? void 0 : _listOfAdvices$value2.length) > 4;
    });
    return {
      listOfAdvices: listOfAdvices,
      isMobile: isMobile,
      isScrollable: isScrollable
    };
  }
});